import React from 'react'

import { Box, Divider, Typography } from '@mui/material'

import Price from '../../../../../pages/Cart/components/Price/Price.component'
import ResponsiveDisplayWrapper from '../../../ResponsiveDisplayWrapper/ResponsiveDisplayWrapper.component'

import styles from './TotalSection.styles'
import { TotalSectionProps } from './TotalSection.types'

const TotalSection: React.FC<TotalSectionProps> = ({ total, currency, showAmountToPay = false }) => {
  if (!showAmountToPay) {
    return null
  }

  return (
    <ResponsiveDisplayWrapper isDesktop>
      <Divider sx={styles.divider} />
      <Box sx={styles.amountToPayContainer}>
        <Typography variant="body1" sx={styles.amountToPayText}>
          Amount to Pay
        </Typography>
        <Price showSeparator={true} currency={currency} superscript={false} price={total} />
      </Box>
    </ResponsiveDisplayWrapper>
  )
}

export default TotalSection
